export default __webpack_public_path__ + "static/media/people.9349a88f.svg";